const IDENTITY_VERIFICATION_PHOTOS_MAX_SIZE_MB = 6;
const IDENTITY_VERIFICATION_PHOTOS_QUALITY = 0.8;

const PATTERNS = {
  dniAndDl: /^[0-9]{8}[a-zA-Z]$/,
  dni: /^[0-9]{8}[a-zA-Z]$/,
  nie: /^[a-zA-Z][0-9]{7}[a-zA-Z]$/,
  name: /^[A-Za-zÀ-ÖØ-öø-ÿ]*(?:\s[A-Za-zÀ-ÖØ-öø-ÿ]+)*(?:\s[а-яА-ЯёЁ]+)*$/,
  nameWithoutAccents: /^[A-Za-z]+(?:\s[A-Za-z]+)*(?:\s[äöüßéèòàùì']+)*$/,
  fiscalCode: /^[A-Za-z0-9]+$/,
  // RFC 5321 mailbox grammar: atext local part, Ldh-str domain labels, 64/254 length caps.
  // Kept in sync with the backend's EMAIL_REGEX (guestapp/constants.py), which drives the
  // guest-form schema, with one deliberate difference: the local part also accepts Unicode
  // letters/digits (RFC 6531). Guest accounts are validated by the guest-accounts service,
  // not Django, so we do not assume Django's ASCII-only rule here.
  // Quoted local parts are rejected: valid per RFC, but the only form that can carry `<`,
  // `>`, spaces or backslashes, and no real provider issues them.
  // No lookbehind — Safari < 16.4 cannot parse it.
  email:
    /^(?=.{1,254}$)(?=.{1,64}@)[\p{L}\p{N}!#$%&'*+/=?^_`{|}~-]+(?:\.[\p{L}\p{N}!#$%&'*+/=?^_`{|}~-]+)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?\.)+[A-Za-z0-9][A-Za-z0-9-]{0,61}[A-Za-z0-9]$/u,
  docNumber: /^\s*[a-zA-Z0-9\s]*$/,
  docNumberWithDots: /^\s*[a-zA-Z0-9 .:\s]*$/,
  time: /\d{2}:\d{2}/,
  numbers: /\D/g,
  onlyNumbers: /^[0-9]*$/,
  phone: /^\+?[1-9]\d{1,14}$/,
};

const DATE_FORMAT = 'YYYY-MM-DD';

enum LANGUAGE_CODES {
  en = 'en',
  es = 'es',
  it = 'it',
  de = 'de',
  fr = 'fr',
  nl = 'nl',
  ko = 'ko',
  hu = 'hu',
  ru = 'ru',
  cs = 'cs',
  bg = 'bg',
  pt = 'pt',
  ro = 'ro',
  et = 'et',
  pl = 'pl',
  ca = 'ca',
  el = 'el',
  uk = 'uk',
  hr = 'hr',
}

const LANGUAGES_ISO_3: {[key: string]: string} = {
  es: 'spa',
  it: 'ita',
  en: 'eng',
  fr: 'fra',
  nl: 'nld',
  ko: 'kor',
  ru: 'rus',
  pt: 'por',
  de: 'deu',
  hu: 'hun',
  cs: 'ces',
  ro: 'ron',
  fn: 'fin',
  bg: 'bul',
  et: 'est',
  hr: 'hrv',
};

enum PAYMENT_METHOD_TYPES {
  payOnline = 'PAY_ONLINE',
  payLater = 'PAY_LATER',
  payOnArrival = 'PAY_ON_ARRIVAL',
}

const ORIGINS = {
  guestApp: 'GUEST_APP',
  guestAppV2: 'GUEST_APP_V2',
  embeddedGuestApp: 'EMBEDDED_GUEST_APP',
  avantio: 'AVANTIO',
  guesty: 'GUESTY',
  guesty2: 'GUESTY_2',
  oracle: 'ORACLE',
  mews2: 'MEWS_2',
};

enum CURRENCIES {
  eur = 'eur',
  usd = 'usd',
  gbp = 'gbp',
  aed = 'aed',
  czk = 'czk',
  chf = 'chf',
}

const CURRENCIES_SIGNS: Record<CURRENCIES, string> = {
  [CURRENCIES.eur]: '€',
  [CURRENCIES.usd]: '$',
  [CURRENCIES.gbp]: '£',
  [CURRENCIES.aed]: 'د.إ',
  [CURRENCIES.czk]: 'Kč',
  [CURRENCIES.chf]: '₣',
};

enum DAY_NAMES {
  monday = 'MON',
  tuesday = 'TUE',
  wednesday = 'WED',
  thursday = 'THU',
  friday = 'FRI',
  saturday = 'SAT',
  sunday = 'SUN',
}

const NONE_EXEMPTION = 'NONE';

export {
  DATE_FORMAT,
  PATTERNS,
  LANGUAGE_CODES,
  LANGUAGES_ISO_3,
  PAYMENT_METHOD_TYPES,
  ORIGINS,
  CURRENCIES,
  DAY_NAMES,
  NONE_EXEMPTION,
  CURRENCIES_SIGNS,
  IDENTITY_VERIFICATION_PHOTOS_MAX_SIZE_MB,
  IDENTITY_VERIFICATION_PHOTOS_QUALITY,
};
